import { Grid } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledButton } from '../../lib/Antd/styledComponents';
import enResource from '../../locales/en/Resources.json';
import fiResource from '../../locales/fi/Resources.json';
import plResource from '../../locales/pl/Resources.json';
import svResource from '../../locales/sv/Resources.json';
const useBreakpoint = Grid.useBreakpoint;

export interface SaveButtonProps {
  disabled: boolean;
  onClick: () => void;
  loading: boolean;
}

export const SaveButton = ({ disabled, onClick, loading }: SaveButtonProps) => {
  const i18n = useTranslation()[1];
  i18n.addResources('en', 'geosecma-settings', enResource.settings);
  i18n.addResources('sv', 'geosecma-settings', svResource.settings);
  i18n.addResources('fi', 'geosecma-settings', fiResource.settings);
  i18n.addResources('pl', 'geosecma-settings', plResource.settings);
  const { t } = useTranslation('geosecma-settings');
  const screens = useBreakpoint();

  return (
    <StyledButton
      block={!screens.lg}
      type="primary"
      data-testid="saveEditsButton"
      disabled={disabled}
      onClick={onClick}
      loading={loading}
    >
      {t('save')}
    </StyledButton>
  );
};
